import { defineStore } from "pinia";
import { ref } from "vue";

export const useAlertStore = defineStore("alert", () => {
  const show = ref(false);
  const message = ref("");
  const colour = ref("primary");
  const pos = ref("bottom");

  const showAlert = (givenMessage, givenColour, givenPos = "bottom") => {
    message.value = givenMessage;
    colour.value = givenColour;
    pos.value = givenPos;
    show.value = true;
  };

  return { show, message, colour, pos, showAlert };
});
